/**
 * An enumeration of all the section types used within DAS.
 */
export enum DasSectionType {
  ATTACHMENTS = 'ATTACHMENTS',
  DEPARTURE_INFORMATION = 'DEPARTURE_INFORMATION',
  LOCATIONS = 'LOCATIONS',
  LINKED_DEPARTURES = 'LINKED_DEPARTURES',
  SPECIALIST_COMMENTS = 'SPECIALIST_COMMENTS',
  SUBMISSION_IN_PREPARATION = 'SUBMISSION_IN_PREPARATION',
  POST_DETERMINATION_COMMENTS = 'POST_DETERMINATION_COMMENTS',
  CONDITIONS = 'CONDITIONS',
}
